import React, { useState, ReactElement, useEffect } from "react";
import { TextField, Button, Grid, Container, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Tab, Tabs } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CTEPContainer from "./ctepContainer";
import { useAppDispatch, useAppSelector } from "core/store/reduxStore";

import {
  Title,
  Subtitle,
  PageContainer,
  Subtitle2
} from "./ctep.styled"
import {
  connectSocket,
  disconnectSocket,
  initSocket,
} from "../../../chat/services/chatSocketService";
import {
  setActiveModel,
  setAiMessageStatus,
  setCurrentConversation,
} from "modules/chat/store/conversationList";



function CTEP() {
    const [title, setTitle] = useState("Welcome!");
    const [subtitle, setSubtitle] = useState("Tell us a little about your current");
    const [subtitle2, setSubtitle2] = useState("Cybersecurity Platform");
    const [socket, setSocket] = useState<any>();
    const dispatch = useAppDispatch();

    const handleStartNewConversation = () => {
        // Reset the load status for messages if one is currently in progress
        dispatch(setAiMessageStatus("init"));

        // Set the current conversation to "", the next message will create a new conversation obj
        dispatch(setCurrentConversation(""));
    };

    useEffect(() => {
        setSocket(initSocket());
        connectSocket();
        handleStartNewConversation();
    
        return () => {
          if (socket) {
            disconnectSocket();
          }
        };
    }, []);

        useEffect(() => {
            const element = document.getElementById('title');
            element?.scrollIntoView({behavior: "smooth"})
        }, [title])

    function pageChange(page) {
        switch (page) {
            case 'current':
                setTitle("Welcome!");
                setSubtitle("Tell us a little about your current");
                setSubtitle2("Cybersecurity Platform");
                break;
            case 'loading questions':
                setTitle("Please Wait");
                setSubtitle("while we generate your questionaire");
                setSubtitle2("");
                break;
            case 'dynamic':
                setTitle("Let's Dive in!");
                setSubtitle("Please carefully fill out the form below so we can");
                setSubtitle2("create the best possible report for you");                
                break;
            case 'loading report':
                setTitle("Please Wait");
                setSubtitle("while we generate your report");
                setSubtitle2("");
                break;
            case 'download':
                setTitle("Congratulations!");
                setSubtitle("You are all done. Please download your custom report below");
                setSubtitle2("");                
                break;
            
        }
    }

    return (
        <PageContainer>
            <Title id="title">{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
            <Subtitle2>{subtitle2}</Subtitle2>
            <CTEPContainer onPageChange={pageChange} socket={socket}></CTEPContainer>
        </PageContainer>
    );
}

export default CTEP;